import { links } from "./Config.resource";

export const getCrossSell = (props = {}) => {
  const { onClickHandler, isAuthenticated } = props;

  return {
    casinoProps: {
      className: "casinoBrand",
      onClick: onClickHandler.onClickCasino,
      href: links.casinoUrl,
      rel: "noopener noreferrer",
      svgId: "default-logo",
      svgText: "casino",
      name: "cross sell_888casino"
    },
    pokerProps: {
      className: "pokerBrand",
      onClick: onClickHandler.onClickPoker,
      href: isAuthenticated ? links.pokerUrlAuthenticated : links.pokerUrl,
      rel: "noopener noreferrer",
      svgId: "default-logo",
      svgText: "poker",
      name: "cross sell_888poker"
    }
  };
};
